module.exports = __webpack_public_path__ + "img/me_and_big_owl.0f1f1999.jpg";